<template>
    <div class="w-full my-md md:my-0 md:w-auto">
        <button
            type="button"
            :disabled="disabled"
            class="btn btn-md text-sm is-ghost is-danger"
            @click="$modal.show('anonymize-user')"
        >
            Anonymisera
        </button>
        <adaptive-form-modal
            name="anonymize-user"
            :primary-button-text="buttonText"
            primary-button-class="is-danger"
            title="Anonymisera användare"
            :action="actionRoute"
            method="patch"
            :redirect-to="redirectRoute"
        >
            Vill du verkligen anonymisera användaren? Detta går inte att ångra.
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
            disabled: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            buttonText() {
                return `Anonymisera ${this.user.name}`;
            },
            actionRoute() {
                return route('admin.users.anonymize', this.user.id);
            },
            redirectRoute() {
                return route('admin.users.index');
            },
        },
    };
</script>
